import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 */
export class ModelDetailFormConfigValueObject extends ValueObject {
  /**
   * @param {Object}  params
   * @param {String}  params.contractId
   * @param {Array}   params.fields
   * @param {Boolean} params.showForm
   */
}
